/*
  THAANI — Geschichte: Scroll-Reveals

  Vergibt 'is-in-view', sobald ein markiertes Element sichtbar wird.
  Wichtig: Die Startwerte der Animationen haengen an 'is-armed', die erst
  dieses Skript setzt. Ohne JS oder bei reduzierter Bewegung bleibt damit
  alles im Endzustand stehen — nichts bleibt unsichtbar haengen.
*/

(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const targets = document.querySelectorAll('[data-g-reveal]');
  if (targets.length === 0) return;

  targets.forEach((element) => element.classList.add('is-armed'));

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in-view');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.25 }
  );

  targets.forEach((element) => observer.observe(element));
})();
